import { render, staticRenderFns } from "./PolicyProvisionModal.vue?vue&type=template&id=6ac3ae60&scoped=true&"
import script from "./PolicyProvisionModal.vue?vue&type=script&lang=js&"
export * from "./PolicyProvisionModal.vue?vue&type=script&lang=js&"
import style0 from "./PolicyProvisionModal.vue?vue&type=style&index=0&id=6ac3ae60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac3ae60",
  null
  
)

export default component.exports